import Head from 'next/head';

export default Head;
/* function ({children}) {
  console.log('children', children);
  return <Head>{children}</Head>;
}
*/
/*
export default function Head({ children }) {
  return <head>
    {children}
  </head>
}
*/
